export const isNumeric = (num) =>
	(typeof num === 'number' ||
		(typeof num === 'string' && num.trim() !== '')) &&
	!Number.isNaN(num);
